import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileUploadUI from "./fileupload/fileuploadui";
import FileUploadEditing from "./fileupload/fileuploadediting";

export default class FileUpload extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'FileUpload';
    }
    /**
     * @inheritDoc
     */
    static get requires() {
        return [FileUploadUI, FileUploadEditing];
    }
}